import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
  // Inicialización síncrona desde matchMedia (cuando hay window) para que el
  // primer render ya conozca el breakpoint y no haya "flash" del drawer móvil
  // abierto en la carga. SSR-safe: si no hay window, arranca en false.
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };
    media.addEventListener('change', listener);

    return () => {
      media.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
}

export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}